if (!customElements.get('counter-animation')) {
  class CounterAnimation extends HTMLElement {
    constructor() {
      super();
      this.counters = this.querySelectorAll('.counter-number');
      this.animated = false;
      this.init();
    }
    
    init() {
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach(entry => {
              if (entry.isIntersecting && !this.animated) {
                this.animated = true;
                this.animateCounters();
              }
            });
          },
          {
            threshold: 0.5,
            rootMargin: '0px'
          }
        );
        
        this.observer.observe(this);
      } else {
        this.animateCounters();
      }
    }
    
    animateCounters() {
      this.counters.forEach(counter => {
        const target = parseFloat(counter.dataset.target);
        const suffix = counter.dataset.suffix || '';
        const duration = 2000;
        const increment = target / (duration / 16); 
        let current = 0;
        
        const updateCounter = () => {
          current += increment;
          
          if (current < target) {
            const formatted = this.formatNumber(Math.floor(current));
            counter.textContent = formatted + suffix;
            requestAnimationFrame(updateCounter);
          } else {
            const formatted = this.formatNumber(target);
            counter.textContent = formatted + suffix;
          }
        };
        
        requestAnimationFrame(updateCounter);
      });
    }
    
    formatNumber(num) {
      return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }
    
    disconnectedCallback() {
      if (this.observer) {
        this.observer.disconnect();
      }
    }
  }
  
  customElements.define('counter-animation', CounterAnimation);
}